import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { toggleTheme } from '../../../../../../infrastructure/redux/reducers/theme';
import { Container, Pages, PageButton, Title } from './styles';
import { finalizarSessao } from '../../../../autenticacao/reducers/autenticacao.reducer';

const Header: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const items = [
    {
      name: 'Home',
      path: '/',
    },
    {
      name: 'Alocação',
      path: '/alocacao',
    },
    {
      name: 'Disciplina',
      path: '/disciplina',
    },
    {
      name: 'Professor',
      path: '/professor',
    },
    {
      name: 'Projeto',
      path: '/projeto',
    },
    {
      name: 'Feriado',
      path: '/feriado',
    },
    {
      name: 'Horário',
      path: '/horario',
    },
    {
      name: 'Período',
      path: '/periodo',
    },
    {
      name: 'Unidade',
      path: '/unidade',
    },
    {
      name: 'Curso',
      path: '/curso',
    },
  ];

  const fazer_logout = () => {
    dispatch(finalizarSessao());
    navigate('/autenticacao/login');
  };

  return (
    <Container>
      <Title onClick={() => dispatch(toggleTheme())}>SisIEC - PUC MG</Title>
      <Pages>
        {items.map((item) => (
          <PageButton
            key={item.name}
            active={pathname === item.path}
            onClick={() => navigate(item.path)}
          >
            {item.name}
          </PageButton>
        ))}
        <PageButton onClick={fazer_logout}>Fazer logout</PageButton>
      </Pages>
    </Container>
  );
};

export { Header };
